import React, { useState, useEffect } from 'react';

// core components
import GridContainer from "../../../components/Grid/GridContainer.js";
import GridItem from "../../../components/Grid/GridItem.js";
import { PostExtendedArea } from "../../../components/PostArea/PostArea.js";
import Skeleton from '@material-ui/lab/Skeleton';
import Pagination from '@material-ui/lab/Pagination';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
//api
import API from '../../../api/api';
import { getImageUrl } from '../../../utils/imageUtils';

const garageApi = new API();

export default function PostSection() {

  const [posts, setPosts] = useState([]);
  const [snackBar, setSnackBar] = useState(false);
  const [postsCount, setPostsCount] = useState(0);
  const [loadingPosts, setLoadingPosts] = useState(false);

  useEffect(() => {
    loadPage(1); // Starte mit Seite 1, nicht 0
  }, []);

  function closeSnackBar (event, reason)
  {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBar(false);
  }

  function loadPage(value) {
    const offset = value > 0 ? ((value - 1) * 10) : 0;
    console.log('Loading posts page:', value, 'offset:', offset);
    
    garageApi.openEndpoints.posts.getPage( { get: { limit: 10, offset: offset } } )
      .then((postsGET) => {
        try
        {
          console.log('Posts API response:', postsGET);
          console.log('Posts data:', postsGET.data);
          
          // Unterstütze sowohl results als auch direkte Arrays
          let posts = [];
          let count = 0;
          
          if (postsGET && postsGET.data) {
            if (Array.isArray(postsGET.data)) {
              // Direktes Array
              posts = postsGET.data;
              count = posts.length;
            } else if (postsGET.data.results && Array.isArray(postsGET.data.results)) {
              // In results verschachtelt
              posts = postsGET.data.results;
              count = postsGET.data.count || posts.length;
            }
          }
          
          console.log('Parsed posts:', posts);
          posts = [...posts].sort((a, b) => {
            const dateA = new Date(a.created || a.updated || 0).getTime();
            const dateB = new Date(b.created || b.updated || 0).getTime();
            if (dateB !== dateA) return dateB - dateA;
            return (Number(b.id) || 0) - (Number(a.id) || 0);
          });
          console.log('Posts count:', count);
          
          setPosts(posts);
          setPostsCount(count);
          setLoadingPosts(true);
        }
        catch(e)
        {
          console.error('Error parsing posts:', e);
          setPosts([]);
          setPostsCount(0);
          setSnackBar(true);
        }

      })
      .catch((error) => {
        console.error('Error loading posts:', error);
        console.error('Error response:', error.response);
        setPosts([]);
        setPostsCount(0);
        setLoadingPosts(true);
      });
  }

  const changePage = (event, value) => {
    loadPage(value);
  };

  return (
    <>
      <Snackbar open={snackBar} autoHideDuration={6000} onClose={closeSnackBar}>
        <MuiAlert elevation={6} variant="filled" onClose={closeSnackBar} severity="warning" >Server Fehler 500</MuiAlert>
      </Snackbar>
      <div className="grid-section">

        <div className="mouse-scroll">
          <div className="mouse">
            <div className="mouse-in"></div>
          </div>
          <div>
              <span className="down-arrow-1"></span>
              <span className="down-arrow-2"></span>
              <span className="down-arrow-3"></span>
           </div>
        </div>
        <GridContainer style={{ marginTop: '60px', marginBottom: '20px'}}>

          { loadingPosts ?
            <>
              { Array.isArray(posts) && posts.length > 0 ? posts.map(function(post, index){
                return (
                  <GridItem xs={12} sm={12} md={12} key={post.unikey || index}>
                    <PostExtendedArea
                      index={index}
                      title={post.title}
                      description={post.description}
                      image={post.image ? getImageUrl(post.image, 'medium') || '' : ''}
                      unikey={post.unikey}
                    />
                  </GridItem>
                )
               }) : null}
             </>
            :
            Array.from({ length: 3 }, (_, i) =>
              <GridItem xs={12} sm={6} md={4}>
                <PostExtendedArea
                  title={<Skeleton variant="text" width={'100%'} />}
                  description=<Skeleton variant="rect" width={'100%'} height={118} />
                  image= <Skeleton variant="rect" width={'100%'} height={200} />
                  key=''
                />
              </GridItem>
            )
          }
          </GridContainer>
          <GridContainer justify="center">
          { postsCount > 10 ?
              <Pagination onChange={changePage} count={(Math.ceil(postsCount/10))} />
            :
            null
          }
        </GridContainer>
      </div>
    </>
  );
}
